module.exports = __webpack_public_path__ + "img/workspace-management.d358e06e.png";